import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Exam } from '../models/exam';
import { AppSettings } from '../../../../utils/app-settings';

@Injectable()
export class ExamsService {

  constructor(private http: HttpClient) { }

  getExams(): Observable<Array<Exam>> {
    return this.http.get<Array<Exam>>(AppSettings.apiUrl + "exams");
  }

  getExamReportCardUrl(examId: number): Observable<string> {
    return this.http.get<string>(`${AppSettings.apiUrl}exams/${examId}/examreport`);
  }

  getExamPromotionReportCardUrl(): Observable<string>{
    return this.http.get<string>(`${AppSettings.apiUrl}exams/promotionreport`);
  }

  getPromotionReportViewStatus(): Observable<boolean>{
    return this.http.get<boolean>(`${AppSettings.apiUrl}exams/promotionreport/view`);
  }

}
